import { Toolbar } from "devextreme-react";
import TabPanel, { Item as TabPanelItem } from "devextreme-react/tab-panel";
import { Item } from "devextreme-react/toolbar";
import React from "react";
import Awards from "./Awards";
import Career from "./Career";
import CertificateOfQualification from "./CertificateOfQualification";
import EducationalHistory from "./EducationalHistory";
import OtherExperienceOrHistory from "./OtherExperienceOrHistory";

export default function History() {
  return (
    <React.Fragment>
      <Toolbar>
        <Item location={"before"}>
          <span
            style={{ fontWeight: 500, color: "#009688", marginLeft: "10px" }}
          >
            HISTORY
          </span>
        </Item>
      </Toolbar>
      <TabPanel id="historyTabPanel" deferRendering={false}>
        <TabPanelItem title={"학력사항"}>
          <EducationalHistory />
        </TabPanelItem>
        <TabPanelItem title={"경력사항"}>
          <Career />
        </TabPanelItem>
        <TabPanelItem title={"수상내력"}>
          <Awards />
        </TabPanelItem>
        <TabPanelItem title={"자격증"}>
          <CertificateOfQualification />
        </TabPanelItem>
        <TabPanelItem title={"기타활동"}>
          <OtherExperienceOrHistory />
        </TabPanelItem>
      </TabPanel>
    </React.Fragment>
  );
}
